import { Lessons } from '../generated/Lessons';
import { ShiftTableDTO } from '../dto/ShiftTableDTO';
import { Communicate } from '../generated/Communicate';
import { Teacher } from '../generated/Teacher';
import { UserAuth } from '../generated/UserAuth';
import { DaTeacher } from '../generated/DaTeacher';

export class LessonListDTO {
  teacher?: Teacher;
  da_teacher?: DaTeacher; // DAのみ利用
  communicate?: Communicate;
  userAuth?: UserAuth;
  star_avg?: number;
  recomend?: boolean;
  lesson_sum?: number;
  price?: number;
  weight?: number;
  schedules: ShiftTableDTO[] = [];
  commitedLessons: Lessons[] = [];
  favorite = false;
  selectedCourse = false;

  static init() {
    const dto = new LessonListDTO();
    dto.teacher = new Teacher();
    dto.da_teacher = new DaTeacher();
    dto.communicate = new Communicate();
    dto.userAuth = new UserAuth();
    dto.star_avg = 0;
    dto.recomend = false;
    dto.lesson_sum = 0;
    dto.price = 0;
    dto.weight = 0;
    dto.schedules = [];
    dto.commitedLessons = [];
    return dto;
  }
}
